import type { TEmbedElement } from '@shared/dream-components';
import { EmbedElement } from '@shared/dream-components';
import { type ReactNode, useId, useMemo } from 'react';
import { ClientOnly } from 'remix-utils/client-only';

interface Props {
  node: TEmbedElement;
  children: ReactNode | ReactNode[];
}
const Embed = ({ node, children }: Props) => {
  const id = useId();
  const { htmlOriginal } = node.attrs;
  // If the embed element has the no-iframe comment, we render it
  // with ClientOnly to avoid hydration issues
  const noIframe = htmlOriginal?.match(/<!--\s*beehiiv:no-iframe\s*-->/);

  const memoizedEmbed = useMemo(() => {
    return (
      <EmbedElement id={id} element={node}>
        {children}
      </EmbedElement>
    );
  }, [id, node, children]);

  if (noIframe) {
    return <ClientOnly>{() => memoizedEmbed}</ClientOnly>;
  }
  return memoizedEmbed;
};

export default Embed;
